import React from 'react'
import "./ToggleButton.css"
import { ReactComponent as CheckboxBlankIcon } from "../../../assets/icons/B-Checkbox.svg";
import { ReactComponent as CheckboxIcon } from "../../../assets/icons/B-Checkbox-fill.svg";
import { ReactComponent as IndeterminateIcon } from "../../../assets/icons/B-Checkbox-indeterminate.svg";

interface ToggleButtonProps {
    className: string;
    label: string;
    checked: boolean;
    indeterminate: boolean;
    icon?: JSX.Element;
    onClick: () => void;
}

const ToggleButton = ({ className, label, checked, indeterminate, icon, onClick }: ToggleButtonProps) => {
    return (
        <div className={className} onClick={onClick}>
            <div className={`${className}-checkbox ${checked ? 'checked' : ''} ${indeterminate ? 'indeterminate' : ''}`}>
                {indeterminate ?
                    <IndeterminateIcon /> : checked ?
                        <CheckboxIcon /> :
                        <CheckboxBlankIcon />
                }
            </div>
            <div className={`${className}-label`}>{label}</div>
            {icon && <div className={`${className}-icon`}>{icon}</div>}
        </div>
    )
}

export default ToggleButton